module.exports = "/static/assets/fd99f9cc8908fdfd24a6cf104952217c.svg";